import React from "react";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { SignupCompanyLogo } from "../widget/SignupWidgets";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import { SignupThirdPartySelectionContextImport } from "../../../../provider/onboarding/signup/third_party_selection/SignupThirdPartySelectionContextProvider";
import { GoogleSignIn } from "../../../../widget/common/ui/SocialSignIn";

const SignupThirdPartyContent = (props: { type: number }) => {
  const type: number = props.type;

  const { socialGoogleSuccess } = SignupThirdPartySelectionContextImport();

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <SignupCompanyLogo
            title={AppTranslation.text("personal_information")}
          />
        </Center>
        <Col xs={12} sm={8} className="mx-auto">
          <TextBlock
            fontSize="16_17"
            fontName="book"
            textColor="theme-sublabel"
            center={true}
          >
            {AppTranslation.text("choose")}
          </TextBlock>
          <SpacingHeight value={type === 2 ? 50 : 40} />

          <div style={{ width: 350 }} className="px-4 px-lg-0">
            <GoogleSignIn
              handleSuccess={socialGoogleSuccess}
              handleFailure={() => {}}
            >
              <div className="d-flex align-items-center pb-3" role="button">
                <IconCircleFilledIcon
                  name="google_ic"
                  className="mx-1"
                  size={type === 1 ? 40 : type === 2 ? 50 : 60}
                />

                <TextBlock
                  fontSize="16_17"
                  fontName="book"
                  textColor="theme-label"
                  center={true}
                  className="ps-3"
                >
                  {AppTranslation.text("google")}
                </TextBlock>
              </div>
            </GoogleSignIn>

            <div
              className="d-flex align-items-center"
              role="button"
              onClick={() =>
                navigate(appRoutes.routeNameSignupPersonalInfo, {
                  replace: true,
                })
              }
            >
              <IconCircleFilledIcon
                name="email2"
                className="mx-1"
                size={type === 1 ? 40 : type === 2 ? 50 : 60}
              />
              <TextBlock
                fontSize="16_17"
                fontName="book"
                textColor="theme-label"
                center={true}
                className="ps-3"
              >
                {AppTranslation.text("continue_with_email")}
              </TextBlock>
            </div>
          </div>
        </Col>
        {type !== 3 && <SpacingHeight value={100} />}
      </Div>
    </Div>
  );
};

export default SignupThirdPartyContent;
